import { useState } from 'react';
import { Duck } from '../components/Duck';
import type { MascotName } from '../theme/ThemeProvider';

export function ComingSoon({ mascot }: { mascot: MascotName }): JSX.Element {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  return (
    <main className="min-h-screen relative overflow-hidden bg-bg text-ink">
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute top-12 right-[8%] opacity-20 motion-safe:animate-pulse">
          <Duck variant={mascot} size={160} />
        </div>
        <div className="absolute bottom-16 left-[4%] opacity-15">
          <Duck variant={mascot} size={120} />
        </div>
      </div>

      <div className="relative mx-auto max-w-3xl px-8 pt-24 pb-16 text-center">
        <span className="inline-flex items-center gap-2 rounded-full border-2 border-ink bg-duck px-3 py-1 font-mono text-xs font-bold text-ink shadow-[3px_3px_0_rgb(var(--color-ink))]">
          <span className="h-2 w-2 rounded-full bg-beak motion-safe:animate-pulse" />
          COMING SOON · MAY 29
        </span>

        <h1 className="mt-8 font-display text-5xl font-black leading-[0.96] tracking-[-0.04em] text-ink sm:text-7xl">
          The{' '}
          <span className="bg-duck px-2 shadow-[4px_4px_0_rgb(var(--color-ink))]">Rubber Duck</span>{' '}
          Debate.
        </h1>

        <p className="mx-auto mt-8 max-w-xl text-xl leading-snug text-ink-soft">
          Semi-live debates where humans and AI bots argue, equally, about whether AI is actually
          any good at engineering. The bots get to talk back.
        </p>

        <div className="mt-12 flex justify-center">
          <Duck variant={mascot} size={220} />
        </div>

        <p className="mt-10 mx-auto max-w-md font-mono text-sm text-ink-soft">
          We're not live yet. Drop your email and we'll send one note when episode 01 goes up.
        </p>

        <form
          className="mx-auto mt-6 flex max-w-md gap-2"
          onSubmit={(e) => {
            e.preventDefault();
            if (email) setSubmitted(true);
          }}
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@somewhere.dev"
            className="flex-1 rounded-full border-2 border-ink bg-paper px-5 py-3 font-display text-base text-ink placeholder:text-ink-soft focus:outline-none"
          />
          <button
            type="submit"
            disabled={submitted}
            className="rounded-full bg-ink px-6 py-3 font-display text-base font-bold text-bg disabled:opacity-60"
          >
            {submitted ? '✓ Saved' : 'Notify me'}
          </button>
        </form>

        <p className="mt-12 font-mono text-xs text-ink-soft">
          QUACK · ARGUE · COMPILE
        </p>
      </div>
    </main>
  );
}
